"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Cristi Ramos Cevallos (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=4635%3A536))
 * @trackcomponent
 * @lastsynced 2023-11-29T16:42:09.161Z
 */
export const Book = createSVGIcon(
  <>
    <g clipPath="url(#clip0_4635_536)">
      <path
        d="M12.0001 22.9106C9.5414 20.2036 6.207 18.4503 2.58332 17.9588C2.17086 17.9132 1.78993 17.7163 1.51404 17.4064C1.23815 17.0964 1.08687 16.6952 1.08939 16.2802V2.76773C1.08937 2.52527 1.14188 2.28569 1.2433 2.06546C1.34472 1.84524 1.49264 1.64961 1.67689 1.49201C1.85789 1.33728 2.06974 1.22283 2.29838 1.15627C2.527 1.08971 2.76719 1.07255 3.00296 1.10594C6.46802 1.68103 9.63788 3.4079 12.0001 6.00737V22.9106Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22.9106C14.4587 20.2036 17.7931 18.4503 21.4168 17.9588C21.8292 17.9132 22.2102 17.7163 22.486 17.4064C22.762 17.0964 22.9132 16.6952 22.9107 16.2802V2.76773C22.9107 2.52527 22.8582 2.28569 22.7568 2.06546C22.6554 1.84524 22.5075 1.64961 22.3232 1.49201C22.1423 1.33728 21.9304 1.22283 21.7018 1.15627C21.473 1.08971 21.233 1.07255 20.9971 1.10594C17.5321 1.68103 14.3622 3.4079 12 6.00737V22.9106Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4635_536">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>,
  "Book",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
